import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../utl/models/Visiable";
import { EmployeesState } from "../models/EmployeesState";

const setMessageVisiable = (state: EmployeesState, action: PayloadAction<Visiable>) => {
    state.messageVisiable = action.payload.visiable;
}

export default setMessageVisiable;